import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
/* eslint-disable import/no-extraneous-dependencies */
import Tooltip from '@mui/material/Tooltip';
// eslint-disable-next-line import/no-extraneous-dependencies
import Icon from '@mui/material/SvgIcon';
import Waffle from '@digital-hig/icon/lib/esm/icons/waffle';
import { AutodeskGenericIcon } from '../common/utilities';

const ProductIcons = ({
  products = [],
}) => {
  const productsArr = (products && products.length) ? products.filter((product) => product.guid !== '00000000-0000-0000-0000-000000000000') : [];
  let productNamesArr = [];
  let productNamesStr = '';
  const productIcons = productsArr.length ? products.filter((product) => product.iconUrl !== null).map((productObj) => productObj.iconUrl).splice(0, 3) : [];

  // handling when atleast one icon or no icons for multiple products
  if (
    (productsArr.length > productIcons.length && productIcons.length < 3)
    || !productIcons.length
  ) {
    productIcons.push('');
  }

  const productNamesWithIcon = [];
  const productNamesWithoutIcon = [];
  if (productsArr.length) {
    productsArr.forEach((product) => {
      if (product.iconUrl) {
        productNamesWithIcon.push(product.displayName);
      } else {
        productNamesWithoutIcon.push(product.displayName);
      }
    });
    productNamesArr = productNamesWithIcon.concat(productNamesWithoutIcon);
    productNamesStr = productNamesArr.toString().replace(/,/g, ', ');
  }

  return (
    <RootElement>
      {productsArr.length ? (
        <Tooltip
          title={productNamesStr}
          arrow
          disableFocusListener
          enterTouchDelay={0}
        >
          <ul className="products">
            {productIcons.length
              && productIcons.map(
                (icon, index) => (
                  <li key={productNamesArr[index]}>
                    {icon && <img src={icon} alt={productNamesArr[index]} width="36" height="36" loading="lazy" />}
                    {!icon && <AutodeskGenericIcon />}
                  </li>
                ),
              )}
            {productsArr.length > productIcons.length && (
              <li className="waffle">
                {/* {`+ ${productsArr.length - productIcons.length}`} */}
                <Icon size="medium"><Waffle /></Icon>
              </li>
            )}
          </ul>
        </Tooltip>
      ) : <></>}
    </RootElement>
  );
};

const RootElement = styled.div`
  img {
    height: 36px;
  }
  ul.products{
    list-style-type: none;
    display: inline-flex;
    align-items: center;
    padding: 0 !important;
    margin: 0 0 6px 0;

    li{
        margin-right: 6px;
        height:34px;
    }

    li.waffle{
        height: 17px;
        width: 30px;
        display: flex;
        margin-left: 4px;
    }
    img {
        margin: 0 !important;
    }
    }
`;

ProductIcons.propTypes = {
  products: PropTypes.arrayOf(PropTypes.shape({ displayName: PropTypes.string }).isRequired),
};

ProductIcons.defaultProps = {
  products: [],
};

export default React.memo(ProductIcons);
